import { REHYDRATE } from "redux-persist";
import { GET_DYNAMIC_ROLE_LIST, RESET_DYNAMIC_ROLE_LIST } from "../ActionTypes";

interface intialState {
  DynamicFilterSecurityForces: any;
  DynamicFilterDivisions: any;
  DynamicFilterUnits: any;
  DynamicFilterStatus: any;
  DynamicRoleListLoading: boolean;
}
const intialState = {
  DynamicFilterSecurityForces: [],
  DynamicFilterDivisions: [],
  DynamicFilterUnits: [],
  DynamicFilterStatus: [],
  DynamicRoleListLoading: true,
};

const DynamicFilterRoleListReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case GET_DYNAMIC_ROLE_LIST:
      return {
        ...state,
        DynamicFilterSecurityForces: action.payload.security_forces,
        DynamicFilterDivisions: action.payload.divisions,
        DynamicFilterUnits: action.payload.units,
        DynamicFilterStatus: action.payload.role_status,
        DynamicRoleListLoading: false,
      };
    case RESET_DYNAMIC_ROLE_LIST:
      return {
        ...state,
        DynamicFilterSecurityForces: [],
        DynamicFilterDivisions: [],
        DynamicFilterUnits: [],
        DynamicFilterStatus: [],
        DynamicRoleListLoading: true,
      };

    case REHYDRATE:
    default:
      return state;
  }
};

export default DynamicFilterRoleListReducer;
